import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { CatalogOtherCostVariableCreateInput } from 'gql/graphql';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { createCatalogOtherCostVariableGql } from '../catalogVariablesQueries';

export const useCreateOtherVariable = ({
    closeModalHandler,
    updateCatalogVariables,
}: {
    closeModalHandler: () => void;
    updateCatalogVariables: () => void;
}) => {
    const dispatch = useDispatch();

    const [resetCreateData] = useResetStoreData({ requestId: 'createCatalogOtherCostVariable' });

    const tempSuccessHandler = useCallback(() => {
        closeModalHandler();
        updateCatalogVariables();
        resetCreateData(undefined);
    }, [closeModalHandler, resetCreateData, updateCatalogVariables]);

    const [, createOtherVariableStatus, , createOtherVariableRequest] = useRequest({
        requestId: 'createCatalogOtherCostVariable',
        query: createCatalogOtherCostVariableGql,
        withEffect: false,
        dependenciesUpdater: tempSuccessHandler,
    });

    const createOtherVariableHandler = useCallback(
        (input: CatalogOtherCostVariableCreateInput) => {
            dispatch(createOtherVariableRequest({ input }));
        },
        [createOtherVariableRequest, dispatch],
    );

    return useMemo(
        () => ({
            createOtherVariableStatus,
            createOtherVariableHandler,
        }),
        [createOtherVariableHandler, createOtherVariableStatus],
    );
};
